import React from "react";
import PropTypes from "prop-types";

import { useFeatures } from "components/FeatureFlag";

import { Modal, UpgradeButton } from "./components";

function UpgradeModal({ title, message, onClose, ...props }) {
  const { pricingLink } = useFeatures("insights-upgrade-plan") || {};

  return (
    <Modal data-test="upgrade-modal" size="mini" isModalOpen onClose={onClose}>
      <Modal.Header onClose={onClose}>{title}</Modal.Header>
      <Modal.Body>
        {message && (
          <div data-test="upgrade-message" style={{ paddingBottom: "20px" }}>
            {message}
          </div>
        )}
        {pricingLink && (
          <div data-test="price-comparison" style={{ paddingBottom: "20px" }}>
            Compare Hubly&apos;s Plan at our{" "}
            <a href={pricingLink} target="_blank" rel="noopener noreferrer">
              Pricing Page
            </a>
          </div>
        )}
        <div style={{ textAlign: "center" }}>
          <UpgradeButton
            data-dd-action-name="change-plan-from-upgrade-modal"
            onClick={onClose}
            {...props}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
}

UpgradeModal.propTypes = {
  title: PropTypes.string,
  message: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

UpgradeModal.defaultProps = {
  title: "Upgrade to Unlock the Feature",
  message: undefined,
};

export default UpgradeModal;
